module.exports = __webpack_public_path__ + "static/media/lease-option-2.ae769c08.jpg";